import { MINIMAX_VIDEO_UPGRADE_CREDITS } from '@/constants/common';

export const MINIMAX_VIDEO_UPGRADE_MODEL = 'MiniMax H3 2K Upgrade';
export const MINIMAX_H3_SOURCE_MODELS = [
  'MiniMax H3',
  'MiniMax H3 Image',
  'MiniMax H3 Reference',
];

export interface MiniMaxUpgradeSource {
  id?: number;
  model?: string | null;
  image_url?: string | null;
  original_video_url?: string | null;
  prompt?: string | null;
  is_processing?: boolean | null;
  request?: Record<string, unknown> | null;
}

// A discovery check for the gallery; the server also validates the saved
// generation inputs and source file before quoting or submitting an upgrade.
export function canUpgradeMiniMaxVideo(video: MiniMaxUpgradeSource): boolean {
  return Boolean(
    video.id &&
      video.image_url &&
      !video.is_processing &&
      video.image_url !== 'https://videos.easy-peasy.ai/202507251214.mp4' &&
      MINIMAX_H3_SOURCE_MODELS.includes(video.model || '') &&
      String(video.request?.resolution).toLowerCase() === '768p' &&
      !video.request?.videoEdit &&
      !video.request?.videoExtend &&
      !video.request?.videoUpscale &&
      !video.request?.minimaxVideoUpgrade,
  );
}

export interface MiniMaxVideoUpgradeQuote {
  sourceVideoId: number;
  sourceVideoUrl: string;
  outputSeconds: number;
  referenceVideoSeconds: number;
  extraReferenceImages: number;
  credits: number;
}

export interface MiniMaxVideoUpgradeRequest {
  videoId: number;
  expectedCredits: number;
}

export function getMiniMaxVideoUpgradeCredits(
  outputSeconds: number,
  referenceVideoSeconds: number,
  extraReferenceImages: number,
): number {
  if (
    !Number.isFinite(outputSeconds) ||
    outputSeconds <= 0 ||
    !Number.isFinite(referenceVideoSeconds) ||
    referenceVideoSeconds < 0 ||
    !Number.isSafeInteger(extraReferenceImages) ||
    extraReferenceImages < 0
  )
    return 0;
  return Math.ceil(
    (outputSeconds + referenceVideoSeconds) *
      MINIMAX_VIDEO_UPGRADE_CREDITS.perSecond +
      extraReferenceImages * MINIMAX_VIDEO_UPGRADE_CREDITS.perExtraImage,
  );
}
